import React from 'react';

class Icon extends React.Component {
  constructor (props) {
    super(props);
  }

  render () {
    const { fa, onClick, className, style } = this.props;
    const newClassName = `Icon fa fa-${fa}${className ? ' ' + className : ''}`;
    return (
      <i onClick={onClick} style={style} className={newClassName} />
    );
  }
};

export default Icon;



// WEBPACK FOOTER //
// ./client/Core/Components/Icon.jsx